// 组件来源：https://element.eleme.cn/2.15/#/zh-CN/component/empty
import Empty from './src/index.vue';

Empty.install = (Vue) => {
  Vue.component(Empty.name, Empty);
};

export default Empty;
